var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSortFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.523438 24.9997C0.523438 31.492 3.10249 37.7183 7.69322 42.3091C12.284 46.8998 18.5103 49.4788 25.0026 49.4788C31.4949 49.4788 37.7212 46.8998 42.312 42.3091C46.9027 37.7183 49.4818 31.492 49.4818 24.9997C49.4818 18.5074 46.9027 12.281 42.312 7.69029C37.7212 3.09956 31.4949 0.520508 25.0026 0.520508C18.5103 0.520508 12.284 3.09956 7.69322 7.69029C3.10249 12.281 0.523438 18.5074 0.523438 24.9997Z",
    fill: "black",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 17.451C12.0098 16.5035 12.7779 15.7354 13.7255 15.7354H24.5098C25.4573 15.7354 26.2255 16.5035 26.2255 17.451C26.2255 18.3986 25.4573 19.1667 24.5098 19.1667H13.7255C12.7779 19.1667 12.0098 18.3986 12.0098 17.451Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 25.0001C12.0098 24.0526 12.7779 23.2844 13.7255 23.2844H22.0588C23.0063 23.2844 23.7745 24.0526 23.7745 25.0001C23.7745 25.9477 23.0063 26.7158 22.0588 26.7158H13.7255C12.7779 26.7158 12.0098 25.9477 12.0098 25.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.843 32.1079L32.843 17.8922C32.843 17.08 33.5014 16.4216 34.3136 16.4216C35.1258 16.4216 35.7842 17.08 35.7842 17.8922L35.7842 32.1079C35.7842 32.9201 35.1258 33.5785 34.3136 33.5785C33.5014 33.5785 32.843 32.9201 32.843 32.1079Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0098 32.5492C12.0098 31.6016 12.7779 30.8335 13.7255 30.8335H20.098C21.0455 30.8335 21.8137 31.6016 21.8137 32.5492C21.8137 33.4967 21.0455 34.2649 20.098 34.2649H13.7255C12.7779 34.2649 12.0098 33.4967 12.0098 32.5492Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6205 14.993L31.0703 17.5433C30.6874 17.9261 30.6874 18.5469 31.0703 18.9297C31.4531 19.3126 32.0739 19.3126 32.4568 18.9297L34.3137 17.0728L36.1707 18.9297C36.5536 19.3126 37.1743 19.3126 37.5572 18.9297C37.94 18.5469 37.94 17.9261 37.5572 17.5433L35.007 14.993C34.6241 14.6102 34.0033 14.6102 33.6205 14.993Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.007 34.9091L37.6812 32.2348C38.0641 31.8519 38.0641 31.2312 37.6812 30.8483C37.2983 30.4655 36.6776 30.4654 36.2947 30.8483L34.3137 32.8293L32.3327 30.8483C31.9498 30.4655 31.3291 30.4655 30.9462 30.8483C30.5634 31.2312 30.5634 31.8519 30.9462 32.2348L33.6205 34.9091C34.0033 35.2919 34.6241 35.2919 35.007 34.9091Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortFilled);
export default __webpack_public_path__ + "static/media/ic_sort_filled.55350ba2faafa407fc7497674701f7ac.svg";
export { ForwardRef as ReactComponent };